/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { getAddressAsync } from '../generated/DataActionExtension.g';
import { IDXC_GetNZPostAddressResponse } from '../generated/DataServiceEntities.g';

/**
 * GetNZPostAddressActionInput Input Action
 */

export class GetNZPostAddressResponseActionInput implements IActionInput {
    public search: string;

    // Construct the input needed to run the action
    constructor(search: string) {
        this.search = search;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'GetNZAddressResponse2020';
    public getCacheObjectType = () => 'GetNZAddressResponse';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: GetNZPostAddressResponseActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getNZAddressResponseAction(
    input: GetNZPostAddressResponseActionInput,
    ctx: IActionContext
): Promise<IDXC_GetNZPostAddressResponse> {

    let addressResult: IDXC_GetNZPostAddressResponse = { success: false };
    return getAddressAsync({ callerContext: ctx }, input.search)
        .then((response) => {
            if (response && !(response instanceof Error)) {
                addressResult = response;
                return addressResult;
            } else {
                return addressResult;
            }
        })
        .catch((error: Error) => {
            ctx.trace(error.message);
            return addressResult;
        });
}

export const ISubmitSubscribeFormDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_GetNZPostAddressResponse>>getNZAddressResponseAction,
    input: createInput
});
